import { isError } from 'core/utilities/exceptionHandler/exceptionHandler';

import type { FetchError } from './coreApiClient';

class ResponseJSONParsingError extends Error {
  override name = 'ResponseJSONParsingError' as const;

  constructor(public cause: Error, msg?: string) {
    super(msg);
  }
}

export const isFetchError = (error: unknown): error is FetchError => {
  if (isError(error) && error.name === 'FetchError') {
    return true;
  }
  return false;
};

export const isResponse = (response: unknown): response is Response => {
  if (response && (response as Response).status) {
    return true;
  }
  return false;
};

/**
 * example: a 404 is a successful response, but it might not contain data and
 * would trigger this error when trying to get the body json
 */
export const isResponseJSONParsingError = (error: unknown): error is ResponseJSONParsingError => {
  if (isError(error) && error.message.match('Unexpected end of JSON input')) {
    return true;
  }
  return false;
};
